export const ISSUE_STATUS_VALUES = ['open', 'retired'] as const;

export type IssueStatus = (typeof ISSUE_STATUS_VALUES)[number];

export const ISSUE_STATUSES: readonly { value: IssueStatus; label: string }[] =
  [
    { value: 'open', label: 'Open' },
    { value: 'retired', label: 'Retired' },
  ];

export const issueStatusLabel = (status: IssueStatus): string =>
  ISSUE_STATUSES.find((entry) => entry.value === status)?.label ?? status;
